import { IGNORED_LOOKUP_DOMAINS } from "./constants";
export async function getActiveEmailContext() {
    const item = Office.context.mailbox?.item;
    if (!item) {
        if (window.location.hostname === "localhost") {
            return getLocalSmokeTestEmail();
        }
        throw new Error("Open this task pane from an Outlook email to load message data.");
    }
    const message = item;
    const bodyText = await getBodyText(message);
    return {
        bodyText,
        cc: toEmailAddresses(message.cc),
        dateTimeCreated: message.dateTimeCreated?.toISOString(),
        from: toEmailAddress(message.from),
        itemId: item.itemId,
        subject: item.subject,
        to: toEmailAddresses(message.to)
    };
}
export function getUserIdentityHeaders() {
    const profile = Office.context.mailbox?.userProfile;
    const email = profile?.emailAddress?.trim().toLowerCase();
    const displayName = profile?.displayName?.trim();
    if (email) {
        return {
            "X-Addin-User-Email": email,
            "X-Addin-User-Id": email
        };
    }
    if (window.location.hostname === "localhost") {
        return {
            "X-Addin-User-Email": "local-smoke-user@example.com",
            "X-Addin-User-Id": "local-smoke-user"
        };
    }
    if (displayName) {
        return {
            "X-Addin-User-Id": displayName.toLowerCase()
        };
    }
    return {};
}
export function openOutlookCompose(emailAddress) {
    const mailbox = Office.context.mailbox;
    if (mailbox.displayNewMessageForm) {
        mailbox.displayNewMessageForm({
            toRecipients: [emailAddress]
        });
        return;
    }
    window.open(`mailto:${encodeURIComponent(emailAddress)}`, "_blank", "noopener");
}
export function collectLookupAddresses(email) {
    const addresses = [email.from, ...email.to, ...email.cc]
        .map((entry) => entry?.emailAddress?.trim().toLowerCase())
        .filter((entry) => Boolean(entry))
        .filter((entry) => !isIgnoredLookupAddress(entry));
    return [...new Set(addresses)];
}
function getLocalSmokeTestEmail() {
    return {
        bodyText: "Local browser smoke test for Outlook Odoo add-in lookup.",
        cc: [],
        dateTimeCreated: new Date().toISOString(),
        from: {
            displayName: "Werkstatt",
            emailAddress: "Werkstatt@B-COS-Services.de"
        },
        subject: "Local Odoo lookup smoke test for Werkstatt@B-COS-Services.de",
        to: []
    };
}
function getBodyText(message) {
    return new Promise((resolve, reject) => {
        message.body.getAsync(Office.CoercionType.Text, (result) => {
            if (result.status === Office.AsyncResultStatus.Failed) {
                reject(new Error(result.error.message));
                return;
            }
            resolve((result.value ?? "").slice(0, 12000));
        });
    });
}
function toEmailAddress(value) {
    if (!value?.emailAddress) {
        return undefined;
    }
    return {
        displayName: value.displayName,
        emailAddress: value.emailAddress
    };
}
function toEmailAddresses(values) {
    return values?.map(toEmailAddress).filter((value) => Boolean(value)) ?? [];
}
function isIgnoredLookupAddress(address) {
    const domain = address.trim().toLowerCase().split("@")[1];
    return Boolean(domain && IGNORED_LOOKUP_DOMAINS.has(domain));
}
